import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = { class: "kn-list--column p-col-4 p-sm-4 p-md-3 p-p-0" }
const _hoisted_4 = { class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0 kn-router-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FabButton = _resolveComponent("FabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_KnListBox = _resolveComponent("KnListBox")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.rolesManagement.title')), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_FabButton, {
              icon: "fas fa-plus",
              onClick: _ctx.showForm,
              "data-test": "open-form-button"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_KnListBox, {
          class: "kn-height-full",
          options: _ctx.roles,
          settings: _ctx.rolesDecriptor.knListSettings,
          onClick: _ctx.showForm,
          onDelete: _withModifiers(_ctx.deleteRoleConfirm, ["stop"])
        }, null, 8, ["options", "settings", "onClick", "onDelete"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_router_view, {
          publicRole: _ctx.publicRole,
          onTouched: _cache[1] || (_cache[1] = ($event: any) => (_ctx.touched = true)),
          onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.touched = false)),
          onInserted: _ctx.pageReload
        }, null, 8, ["publicRole", "onInserted"])
      ])
    ])
  ]))
}